<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
      <h3 class="card-title">Lista de Autorización consulta de buró</h3>
      <div class="d-flex">
        <!-- Botón para abrir la modal justify-content-end -->
        <PrimaryButton class="btn btn-primary ms-auto" data-toggle="modal" data-target="#modal-xl"
          @click="prepareModal">
          Generar
        </PrimaryButton>
      </div>
    </div>

    <div class="d-flex mt-3 mb-3">
      <input type="text" class="form-control" placeholder="Buscar Autorización consulta de buró..."
        v-model="searchString" />
    </div>

    <div>
      <!-- Tabla -->
      <AuthorizationBureauConsultationTable :list="filteredListAuthorizationBureau" :itemsPerPage="itemsPerPage"
        :currentPage="currentPage" @edit-item="setEditItem" />
      <Pagination v-if="filteredListAuthorizationBureau.length > itemsPerPage" :list="filteredListAuthorizationBureau"
        :itemsPerPage="itemsPerPage" :currentPage="currentPage" @current-page="handlePageChange" />
    </div>

    <!-- Modal -->
    <Modal :modalId="'modal-xl'" :customClass="'modal-xl'" ref="bureauModal">
      <div class="modal-header">
        <h4 class="modal-title">Autorización consulta de buró</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="handleModalClose">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-4">
              <div class="col-12 col-md-3 col-lg-3 content-col">
                <label for="applicationSelect" class="mb-0 font-weight-lb">Solicitud:</label>
              </div>
              <div class="col-12 col-md-4 col-lg-4" v-show="!isEdit">
                <select id="applicationSelect" v-model="selectedApplication"
                  class="form-select selectpicker border-dark" data-width="100%" data-live-search="true"
                  :disabled="!applications.length" title="Selecciona solicitud...">
                  <option value="" disabled>Selecciona solicitud</option>
                  <option v-for="application in applications" :key="application.id" :value="application">
                    {{ application.referenceNumber }}
                  </option>
                </select>
              </div>
              <div class="col-12 col-md-4 col-lg-4" v-show="isEdit">
                <label for="applicationSelect" class="mb-0 font-weight-lb">
                  {{ applicationReference }}
                </label>
              </div>
            </div>
          </div>
          <AuthorizationBureauConsultation :formData="formData" :editAction="isEdit" :editId="dataIdEdit" />
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="handleModalClose">
          {{ $getLocaleMessage('buttons', 'cerrar') }}
        </button>
      </div>
    </Modal>
  </div>
</template>

<!--Mezclando opciones API de Vue (Options API y Composition API) -->
<script>
import "bootstrap-select/dist/css/bootstrap-select.min.css";
import "bootstrap-select";
import { ref, computed, watch, nextTick, reactive, onMounted, onBeforeMount, getCurrentInstance } from "vue";
import Modal from '@/Components/Bootstrap/Modal.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import AuthorizationBureauConsultationTable from '@/Components/Tables/AuthorizationBureauConsultationTable.vue';
import Pagination from '@/Components/Bootstrap/Pagination.vue';
import AuthorizationBureauConsultation from '@/Components/Forms/LoanApplications/Legal/AuthorizationBureauConsultation.vue';
import { useAuthorizationBureauConsultationStore } from "@/pinia/LoanApplications/Legal/authotizationBureauConsultation.module";

export default {
  components: {
    PrimaryButton,
    Modal,
    AuthorizationBureauConsultationTable,
    Pagination,
    AuthorizationBureauConsultation
  },
  setup() {
    /**Configuración de consulta al Store */
    const bureauStore = useAuthorizationBureauConsultationStore();
    /**Configuración de la paginación y interacción de búsqueda de la tabla */
    const currentPage = ref(1);
    const itemsPerPage = ref(10);
    const instance = getCurrentInstance();
    const searchString = ref('');

    /**Configuración de combo de selección dentro de la modal */
    const applications = ref([]);
    const selectedApplication = ref(null);

    /**Configuración de banderas */
    const isLoading = ref(false);
    const isLoadingData = ref(false);
    const isEdit = ref(false);

    /**Configuración de Formulario y datos de interacción */
    const dataIdEdit = ref(null);
    const applicationReference = ref('');
    const statusBC = 21;
    const formData = reactive({
      placeIssuance: '',
      dateIssuance: '',
      pf: false,
      pfae: false,
      pm: false,
      nombreSolicitante: '',
      representanteLegal: '',
      rfcCurp: '',
      domicilio: '',
      colonia: '',
      municipio: '',
      estado: '',
      telefonos: '',
      signedAddress: '',
      signedDate: '',
      officerFullName: '',
      inquiryDate: '',
      referenceNumber: '',
      companyName: '',
      loanApplicationId: null,
      statusId: null
    });

    onMounted(async () => {
      initializeSelectPicker();
      try {
        isLoadingData.value = true;
        await bureauStore.fetchBureauConsultations(); // <-- Consulta la API
      } catch (error) {
        console.error("Error loading authotization bureau:", error);
      } finally {
        isLoadingData.value = false;
      }
    });

    // Carga de la información de los datos de la tabla de Autorización consulta de buró
    const filteredListAuthorizationBureau = computed(() => {
      return bureauStore.filterAuthorizationBureauConsultationBySearchString(searchString.value) || [];
    });

    // Carga de la información de los datos del combo/filtro de solicitud manera efectiva
    const loadApplications = async () => {
      try {
        isLoading.value = true;

        // Primero cargamos las solicitudes desde la API
        await bureauStore.filterBureauLoanApplications();

        if (Array.isArray(bureauStore.loanApplicationsOptions)) {
          // Luego obtenemos las solicitudes ya cargadas en la store
          applications.value = bureauStore.loanApplicationsOptions;
        } else {
          applications.value = [];
          console.warn("No se encontraron solicitudes");
        }

        initializeSelectPicker();
      } catch (error) {
        console.error("Error loading applications:", error);
        applications.value = [];
      } finally {
        isLoading.value = false;
      }
    };

    // Inicializa el selectpicker
    const initializeSelectPicker = () => {
      nextTick(() => {
        const select = $('#applicationSelect');
        if (select.length) {
          select.selectpicker('refresh');
          if (!selectedApplication.value) {
            select.selectpicker('val', '');
          }
        }
      });
    };

    /**Resetear información y formulario */
    // Función para limpiar el formulario
    const clearFormData = () => {
      Object.assign(formData, {
        placeIssuance: '',
        dateIssuance: '',
        pf: false,
        pfae: false,
        pm: false,
        nombreSolicitante: '',
        representanteLegal: '',
        rfcCurp: '',
        domicilio: '',
        colonia: '',
        municipio: '',
        estado: '',
        telefonos: '',
        signedAddress: '',
        signedDate: '',
        officerFullName: '',
        inquiryDate: '',
        referenceNumber: '',
        companyName: '',
        loanApplicationId: null,
        statusId: null
      });
    };

    // Función para refrescar los datos de la tabla
    const refreshTableData = async () => {
      try {
        isLoadingData.value = true;
        await bureauStore.fetchBureauConsultations();
      } catch (error) {
        console.error("Error refreshing bureau consultations:", error);
      } finally {
        isLoadingData.value = false;
      }
    };

    /**Eventos de interacción de la sección */
    // Preparamos los datos que se van a requerir al abrir la modal
    const prepareModal = async () => {
      
      searchString.value = '';
      await loadApplications(); // Mandamos a llamar la carga del combo/filtro de solicitud que se requiere dentro de la modal
    };

    // Preparamos los datos que se van a requerir al cerrar la modal
    const handleModalClose = async () => {
      try {
        await refreshTableData(); // Primero refrescar datos
      } catch (error) {
        console.error("Error refreshing data:", error);
      } finally {
        clearFormData(); // Luego limpiar el formulario
        selectedApplication.value = null;
        isEdit.value = false;
        dataIdEdit.value = null;
        initializeSelectPicker(); // Y reiniciar el picker
      }
    };

    // Watcher para la solicitud seleccionada
    watch(selectedApplication, async (application) => {

      /**Si resulta que se abrio la modal de edición este no limpia los datos de la autorización de buro */
      if (!isEdit.value) {
        clearFormData();
      }

      if (application) {
        try {
          isLoadingData.value = true;

          //Datos de solicitud
          formData.loanApplicationId = application.id;

          //Datos del prospecto
          switch (application.prospectus.personType.id) {
            case 1:
              formData.pf = true;
              formData.nombreSolicitante = `${application.prospectus.generalInformation.firstName} ${application.prospectus.generalInformation.lastName} ${application.prospectus.generalInformation.mothersMaidenName}` || '';
              formData.representanteLegal = "";
              break;
            case 2:
              formData.pm = true;
              formData.nombreSolicitante = application.prospectus.generalInformation.businessName || '';
              formData.representanteLegal = `${application.prospectus.legalRepresentative.firstName} ${application.prospectus.legalRepresentative.lastName} ${application.prospectus.legalRepresentative.mothersMaidenName}`;
              break;
            case 3:
              formData.pfae = true;
              formData.nombreSolicitante = "";
              formData.representanteLegal = "";
              break;
            default:
              formData.pf = false;
              formData.pm = false;
              formData.pfae = false;
              formData.nombreSolicitante = "";
              formData.representanteLegal = "";
              break;
          }
          formData.rfcCurp = (application.prospectus.generalInformation.rfc === null ? application.prospectus.generalInformation.curp : application.prospectus.generalInformation.rfc) || "";
          formData.domicilio = `${application.prospectus.fiscalAddress.street} ${application.prospectus.fiscalAddress.exteriorNumber} ${application.prospectus.fiscalAddress.interiorNumber}`;
          formData.colonia = application.prospectus.fiscalAddress.district;
          formData.municipio = application.prospectus.fiscalAddress.municipality;
          formData.estado = application.prospectus.fiscalAddress.state;

          const phones = [
            application.prospectus.generalInformation.homePhone,
            application.prospectus.generalInformation.officePhone,
            application.prospectus.generalInformation.cellPhone
          ].filter(phone => phone !== null);
          formData.telefonos = phones.join(' | ');

          //Datos de autorizcion
          formData.statusId = statusBC;
        } catch (error) {
          console.error("Error loading prospecto:", error);
        } finally {
          isLoadingData.value = false;
        }
      }
    });

    /**Control de la paginación */
    const handlePageChange = (page) => {
      currentPage.value = page;
      nextTick(() => {
        instance?.proxy?.$forceUpdate();
      });
    };

    /**Para edición */
    const setEditItem = async (item) => {
      
      searchString.value = '';
      isEdit.value = true;

      /**Datos de la autorización de Buro */
      formData.placeIssuance = item.placeIssuance;
      formData.dateIssuance = item.dateIssuance;
      formData.signedAddress = item.signedAddress;
      formData.signedDate = item.signedDate;
      formData.officerFullName = item.officerFullName;
      formData.inquiryDate = item.inquiryDate;
      formData.referenceNumber = item.referenceNumber;
      dataIdEdit.value = item.id;
      /**Datos de la solicitud */
      applicationReference.value = item.loanApplication.referenceNumber;
      selectedApplication.value = item.loanApplication;
    }

    return {
      applications,
      selectedApplication,
      formData,
      isLoading,
      loadApplications,
      prepareModal,
      handleModalClose,
      initializeSelectPicker,
      filteredListAuthorizationBureau,
      searchString,
      clearFormData,
      refreshTableData,
      setEditItem,
      isEdit,
      applicationReference,
      dataIdEdit,
      currentPage,
      itemsPerPage,
      handlePageChange
    };
  }
}
</script>